import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ArrowLeft, Briefcase, User } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { Logo } from "../components/Header";

export default function LoginPage({ type }) {
  const { t, isRtl } = useLang();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const isEmployer = type === "employer";
  const Icon = isEmployer ? Briefcase : User;

  const submit = (e) => {
    e.preventDefault();
    toast.info(t("login.soon"));
  };

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex dot-grid" data-testid={`${type}-login-page`}>
      <div className="hidden lg:block relative w-1/2 overflow-hidden">
        <img src={isEmployer ? "/assets/hero-2.jpg" : "/assets/hero-3.jpg"} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1B2A4E] via-[#1B2A4E]/50 to-[#1B2A4E]/20" />
        <div className="absolute bottom-12 start-12 max-w-md">
          <p className="font-head font-black text-3xl text-white leading-snug">{t("tagline")}</p>
          <p className="text-[#F5A623] text-sm font-bold mt-2 tracking-widest uppercase">Hire Host — Since 1998</p>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center px-6 py-16">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="w-full max-w-md">
          <div className="inline-block rounded-2xl overflow-hidden shadow-md">
            <img src="/assets/logo-web.png" alt="Hire Host" className="h-14 w-auto" />
          </div>
          <div className="mt-10 mb-8">
            <div className="w-14 h-14 rounded-2xl bg-[#E8842C]/15 border border-[#E8842C]/30 flex items-center justify-center mb-6">
              <Icon className="w-7 h-7 text-[#E8842C]" />
            </div>
            <h1 className="font-head font-black text-3xl text-[#1B2A4E]" data-testid="login-title">
              {isEmployer ? t("login.employer_title") : t("login.employee_title")}
            </h1>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="label">{t("login.email")}</label>
              <input data-testid="login-email" type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label className="label">{t("login.password")}</label>
              <input data-testid="login-password" type="password" required className="field" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <button type="submit" data-testid="login-submit-btn" className="btn-primary w-full justify-center !py-3.5">
              {t("login.submit")}
            </button>
          </form>

          <Link to="/" data-testid="login-back-home" className="mt-8 inline-flex items-center gap-2 text-sm text-[#1B2A4E]/60 hover:text-[#E8842C] transition-colors font-bold">
            <ArrowLeft className={`w-4 h-4 ${isRtl ? "rotate-180" : ""}`} /> {t("login.back")}
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
